/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Code3Inputs */

const en_reference_field_code3 = /** @type {(inputs: Reference_Field_Code3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3-letter code`)
};

/**
* | output |
* | --- |
* | "3-letter code" |
*
* @param {Reference_Field_Code3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_code3 = /** @type {((inputs?: Reference_Field_Code3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Code3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_code3(inputs)
});